export default __webpack_public_path__ + "static/media/toji-img.50e37af0.jpg";